module.exports = __webpack_public_path__ + "static/media/Backon.10b51364.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Icons/Backon.svg
// module id = 1150
// module chunks = 0